import React from 'react';
import PropTypes from 'prop-types';

export const GenericGridHeader = ({ fields = [] }) => (
    <thead>
        <tr>
            {fields.map(({ fieldName, settings }, index) => (
                <th key={index} style={{backgroundColor: settings.backgroundColor || null}}>{fieldName}</th>
            ))}
        </tr>
    </thead>
);

GenericGridHeader.propTypes = {
    fields: PropTypes.array,
};

GenericGridHeader.displayName = 'GenericGridHeader';
